import ahsanSajidImage from "@/assets/ahsan-sajid.png";
export const LlmIntegrationFounderQuote = () => (
  <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
    <div className="flex items-start gap-4">
      <img src={ahsanSajidImage} alt="Ahsan Sajid" className="w-14 h-14 rounded-full object-cover border-2 border-primary/20" />
      <div><blockquote className="text-foreground italic leading-relaxed">"When adding AI features, always discuss costs upfront. API calls add up fast, and I've seen projects blow their budgets in weeks. Design with cost controls from day one — rate limiting, caching, and fallbacks. A smart LLM integration pays for itself; a careless one becomes a money pit."</blockquote>
        <div className="mt-4"><p className="font-semibold text-foreground">Ahsan Sajid</p><p className="text-sm text-muted-foreground">Owner, IT Dukes</p></div>
      </div>
    </div>
  </div>
);
